<template>
  <div class="w-full flex flex-col justify-between gap-10 items-center max-md:gap-5">
    <div v-if="!loadingData && productData && suggestedLoaded" class="w-full flex flex-col justify-between">
      <div class="w-full flex justify-end py-5 items-center sticky top-0 bg-white px-[5vw] shadow-md">
        <router-link :to="{ name: 'category', query: { id: route.query.categoryId } }"
          class="hover:bg-neutral-100 duration-200 rounded-full p-2">
          <svg class="text-neutral-400" xmlns="http://www.w3.org/2000/svg" width="1.5rem" height="1.5rem"
            viewBox="0 0 24 24">
            <g class="text-inherit" fill="none" fill-rule="evenodd">
              <path
                d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
              <path class="text-inherit" fill="currentColor"
                d="m12 14.122l5.303 5.303a1.5 1.5 0 0 0 2.122-2.122L14.12 12l5.304-5.303a1.5 1.5 0 1 0-2.122-2.121L12 9.879L6.697 4.576a1.5 1.5 0 1 0-2.122 2.12L9.88 12l-5.304 5.304a1.5 1.5 0 1 0 2.122 2.12z" />
            </g>
          </svg>
        </router-link>
      </div>

      <div class="flex flex-nowrap max-sm:flex-col max-w-[1400px] mx-auto px-[5vw] pt-[5vh]">
        <div class="w-[50%] flex flex-col gap-2 max-sm:w-full px-10 max-md:px-[2vw]">
          <div class="w-full aspect-square flex items-center justify-center border-2 rounded-md shadow-md">
            <img v-if="!imgLoading" class="w-full bg-neutral-100 rounded-md aspect-square object-contain object-center"
              :src="vImages[vIndex]?.[vIndexImage]" :alt="productData ? productData.name + `'s Image` : ''" />
            <div v-if="imgLoading">
              <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="3rem" height="3rem"
                viewBox="0 0 24 24">
                <defs>
                  <linearGradient id="mingcuteLoadingFill0" x1="50%" x2="50%" y1="5.271%" y2="91.793%">
                    <stop offset="0%" stop-color="#FFB908" />
                    <stop offset="100%" stop-color="#FFB908" stop-opacity="0.55" />
                  </linearGradient>
                  <linearGradient id="mingcuteLoadingFill1" x1="50%" x2="50%" y1="15.24%" y2="87.15%">
                    <stop offset="0%" stop-color="#FFB908" stop-opacity="0" />
                    <stop offset="100%" stop-color="#FFB908" stop-opacity="0.55" />
                  </linearGradient>
                </defs>
                <g fill="none">
                  <path
                    d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                  <path fill="url(#mingcuteLoadingFill0)"
                    d="M8.749.021a1.5 1.5 0 0 1 .497 2.958A7.502 7.502 0 0 0 3 10.375a7.5 7.5 0 0 0 7.5 7.5v3c-5.799 0-10.5-4.7-10.5-10.5C0 5.23 3.726.865 8.749.021"
                    transform="translate(1.5 1.625)" />
                  <path fill="url(#mingcuteLoadingFill1)"
                    d="M15.392 2.673a1.5 1.5 0 0 1 2.119-.115A10.475 10.475 0 0 1 21 10.375c0 5.8-4.701 10.5-10.5 10.5v-3a7.5 7.5 0 0 0 5.007-13.084a1.5 1.5 0 0 1-.115-2.118"
                    transform="translate(1.5 1.625)" />
                </g>
              </svg>
            </div>
          </div>
          <div v-if="multipleImg" class="w-full grid grid-cols-5 gap-2 place-items-center">
            <button v-for="(image, index) in selectedVarImgs" :key="index" @click="selectImage(index)" target="_blank"
              class="w-full">
              <img v-if="!imgLoading" :src="vImages[vIndex]?.[index]"
                class="md:hover:border-Primary duration-200 border-2 rounded-md shadow-md w-full object-cover bg-neutral-100 object-center aspect-square"
                :alt="productData ? productData.name + `'s Image` : ''" />
              <div v-if="imgLoading">
                <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="3rem" height="3rem"
                  viewBox="0 0 24 24">
                  <defs>
                    <linearGradient id="mingcuteLoadingFill0" x1="50%" x2="50%" y1="5.271%" y2="91.793%">
                      <stop offset="0%" stop-color="#FFB908" />
                      <stop offset="100%" stop-color="#FFB908" stop-opacity="0.55" />
                    </linearGradient>
                    <linearGradient id="mingcuteLoadingFill1" x1="50%" x2="50%" y1="15.24%" y2="87.15%">
                      <stop offset="0%" stop-color="#FFB908" stop-opacity="0" />
                      <stop offset="100%" stop-color="#FFB908" stop-opacity="0.55" />
                    </linearGradient>
                  </defs>
                  <g fill="none">
                    <path
                      d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                    <path fill="url(#mingcuteLoadingFill0)"
                      d="M8.749.021a1.5 1.5 0 0 1 .497 2.958A7.502 7.502 0 0 0 3 10.375a7.5 7.5 0 0 0 7.5 7.5v3c-5.799 0-10.5-4.7-10.5-10.5C0 5.23 3.726.865 8.749.021"
                      transform="translate(1.5 1.625)" />
                    <path fill="url(#mingcuteLoadingFill1)"
                      d="M15.392 2.673a1.5 1.5 0 0 1 2.119-.115A10.475 10.475 0 0 1 21 10.375c0 5.8-4.701 10.5-10.5 10.5v-3a7.5 7.5 0 0 0 5.007-13.084a1.5 1.5 0 0 1-.115-2.118"
                      transform="translate(1.5 1.625)" />
                  </g>
                </svg>
              </div>
            </button>
          </div>
          <div class="flex flex-col gap-3 my-2 sm:items-center sm:justify-center">
            <label class="sm:text-center text-gray-500 text-sm">Want this product? <br />Message us on our social media accounts below: </label>
            <div class="flex gap-3 items-center">
              <a class="hover:-translate-y-1 duration-200" href="https://www.facebook.com/datesfruitphilippines" target="_blank">
              <img class="w-8 h-8" src="https://i.pinimg.com/originals/ce/d6/6e/ced66ecfc53814d71f8774789b55cc76.png" alt="">                    
            </a>
            <a class="hover:-translate-y-1 duration-200" href="https://www.instagram.com/datesfruitphilippines/" target="_blank">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><g fill="none"><rect width="256" height="256" fill="url(#skillIconsInstagram0)" rx="60"/><rect width="256" height="256" fill="url(#skillIconsInstagram1)" rx="60"/><path fill="#fff" d="M128.009 28c-27.158 0-30.567.119-41.233.604c-10.646.488-17.913 2.173-24.271 4.646c-6.578 2.554-12.157 5.971-17.715 11.531c-5.563 5.559-8.98 11.138-11.542 17.713c-2.48 6.36-4.167 13.63-4.646 24.271c-.477 10.667-.602 14.077-.602 41.236s.12 30.557.604 41.223c.49 10.646 2.175 17.913 4.646 24.271c2.556 6.578 5.973 12.157 11.533 17.715c5.557 5.563 11.136 8.988 17.709 11.542c6.363 2.473 13.631 4.158 24.275 4.646c10.667.485 14.073.604 41.23.604c27.161 0 30.559-.119 41.225-.604c10.646-.488 17.921-2.173 24.284-4.646c6.575-2.554 12.146-5.979 17.702-11.542c5.563-5.558 8.979-11.137 11.542-17.712c2.458-6.361 4.146-13.63 4.646-24.272c.479-10.666.604-14.066.604-41.225s-.125-30.567-.604-41.234c-.5-10.646-2.188-17.912-4.646-24.27c-2.563-6.578-5.979-12.157-11.542-17.716c-5.562-5.562-11.125-8.979-17.708-11.53c-6.375-2.474-13.646-4.16-24.292-4.647c-10.667-.485-14.063-.604-41.23-.604zm-8.971 18.021c2.663-.004 5.634 0 8.971 0c26.701 0 29.865.096 40.409.575c9.75.446 15.042 2.075 18.567 3.444c4.667 1.812 7.994 3.979 11.492 7.48c3.5 3.5 5.666 6.833 7.483 11.5c1.369 3.52 3 8.812 3.444 18.562c.479 10.542.583 13.708.583 40.396s-.104 29.855-.583 40.396c-.446 9.75-2.075 15.042-3.444 18.563c-1.812 4.667-3.983 7.99-7.483 11.488c-3.5 3.5-6.823 5.666-11.492 7.479c-3.521 1.375-8.817 3-18.567 3.446c-10.542.479-13.708.583-40.409.583c-26.702 0-29.867-.104-40.408-.583c-9.75-.45-15.042-2.079-18.57-3.448c-4.666-1.813-8-3.979-11.5-7.479s-5.666-6.825-7.483-11.494c-1.369-3.521-3-8.813-3.444-18.563c-.479-10.542-.575-13.708-.575-40.413s.096-29.854.575-40.396c.446-9.75 2.075-15.042 3.444-18.567c1.813-4.667 3.983-8 7.484-11.5s6.833-5.667 11.5-7.483c3.525-1.375 8.819-3 18.569-3.448c9.225-.417 12.8-.542 31.437-.563zm62.351 16.604c-6.625 0-12 5.37-12 11.996c0 6.625 5.375 12 12 12s12-5.375 12-12s-5.375-12-12-12zm-53.38 14.021c-28.36 0-51.354 22.994-51.354 51.355s22.994 51.344 51.354 51.344c28.361 0 51.347-22.983 51.347-51.344c0-28.36-22.988-51.355-51.349-51.355zm0 18.021c18.409 0 33.334 14.923 33.334 33.334c0 18.409-14.925 33.334-33.334 33.334s-33.333-14.925-33.333-33.334c0-18.411 14.923-33.334 33.333-33.334"/><defs><radialGradient id="skillIconsInstagram0" cx="0" cy="0" r="1" gradientTransform="matrix(0 -253.715 235.975 0 68 275.717)" gradientUnits="userSpaceOnUse"><stop stop-color="#fd5"/><stop offset=".1" stop-color="#fd5"/><stop offset=".5" stop-color="#ff543e"/><stop offset="1" stop-color="#c837ab"/></radialGradient><radialGradient id="skillIconsInstagram1" cx="0" cy="0" r="1" gradientTransform="matrix(22.25952 111.2061 -458.39518 91.75449 -42.881 18.441)" gradientUnits="userSpaceOnUse"><stop stop-color="#3771c8"/><stop offset=".128" stop-color="#3771c8"/><stop offset="1" stop-color="#60f" stop-opacity="0"/></radialGradient></defs></g>
              </svg>
            </a>
            </div>
          </div>
        </div>

        <div class="w-[50%] max-md:px-[2vw] max-sm:w-full pb-5 px-10 flex flex-col divide-y divide-neutral-300">
          <div class="flex flex-col gap-7 pb-5">
            <h1 class="font-semibold text-2xl">{{ productData.name }}</h1>

            <div class="flex flex-col gap-2">
              <!-- <h2 class="font-medium text-lg">{{ productData.descTitle ? 'productData.descTitle' : 'descTitle placeholder' }}</h2> -->
              <p class="text-sm">
                <span ref="description">
                  {{ limitShow(productData.description) }}
                </span>
                <span>&nbsp;</span>
                <button ref="seeMoreBtn" @click="toggleFullDescription" class="hover: duration-200 font-semibold"
                  v-if="productData.description.length > 200">
                  See more
                </button>
              </p>
            </div>
          </div>

          <!-- Price -->
          <div class="font-semibold text-2xl w-full py-5" v-if="selectedVariation">
            ₱{{ selectedVariation.price }}
          </div>

          <!-- Flavor -->
          <div class="py-5 flex flex-col gap-2" v-if="flavors.length != 0">
            <span class="font-semibold block mb-1">Flavor Profile</span>
            <div class="flex flex-row flex-nowrap items-center gap-3" v-for="flavor in flavors" :key="flavor._id">
              <span>{{ flavor.flavour }}:</span>
              <div class="flex flex-nowrap gap-1">
                <template v-for="(i, index) in flavor.max_value" :key="index">
                  <div class="bg-Primary w-3 h-5" v-if="i <= flavor.min_value"></div>
                  <div class="bg-neutral-200 w-3 h-5" v-else></div>
                </template>
              </div>
            </div>
          </div>

          <!-- Option -->
          <div class="py-5 flex flex-col gap-2">
            <span class="font-semibold block mb-1">Options</span>
            <div class="flex flex-wrap gap-2">
              <button ref="variationButtons" @click="() => updateSelectedVariation(variant, index)"
                v-for="(variant, index) in productData.variants" :key="index" :class="{
                  'border-neutral-300': index != 0,
                  'border-Primary': index == 0,
                }"
                class="md:hover:-translate-y-1 duration-200 border-2 rounded-sm flex flex-nowrap p-2 gap-2 items-center">
                <img v-if="!imgLoading" class="aspect-square w-5" :src="vImages[index]?.[0]" alt="" />
                <div v-if="imgLoading">
                  <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="3rem" height="3rem"
                    viewBox="0 0 24 24">
                    <defs>
                      <linearGradient id="mingcuteLoadingFill0" x1="50%" x2="50%" y1="5.271%" y2="91.793%">
                        <stop offset="0%" stop-color="#FFB908" />
                        <stop offset="100%" stop-color="#FFB908" stop-opacity="0.55" />
                      </linearGradient>
                      <linearGradient id="mingcuteLoadingFill1" x1="50%" x2="50%" y1="15.24%" y2="87.15%">
                        <stop offset="0%" stop-color="#FFB908" stop-opacity="0" />
                        <stop offset="100%" stop-color="#FFB908" stop-opacity="0.55" />
                      </linearGradient>
                    </defs>
                    <g fill="none">
                      <path
                        d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                      <path fill="url(#mingcuteLoadingFill0)"
                        d="M8.749.021a1.5 1.5 0 0 1 .497 2.958A7.502 7.502 0 0 0 3 10.375a7.5 7.5 0 0 0 7.5 7.5v3c-5.799 0-10.5-4.7-10.5-10.5C0 5.23 3.726.865 8.749.021"
                        transform="translate(1.5 1.625)" />
                      <path fill="url(#mingcuteLoadingFill1)"
                        d="M15.392 2.673a1.5 1.5 0 0 1 2.119-.115A10.475 10.475 0 0 1 21 10.375c0 5.8-4.701 10.5-10.5 10.5v-3a7.5 7.5 0 0 0 5.007-13.084a1.5 1.5 0 0 1-.115-2.118"
                        transform="translate(1.5 1.625)" />
                    </g>
                  </svg>
                </div>
                <span class="text-left">{{ variant.title }}</span>
              </button>
            </div>
          </div>

          <div class="w-full py-5 flex flex-col gap-2">
            <button @click="nutritionOpen = !nutritionOpen"
              class="w-full flex flex-nowrap justify-between items-center">
              <span class="font-semibold block mb-1">Nutrition Facts</span>
              <svg :class="{ 'rotate-180': nutritionOpen }" class="duration-200" xmlns="http://www.w3.org/2000/svg"
                width="1rem" height="1rem" viewBox="0 0 24 24">
                <g fill="none" fill-rule="evenodd">
                  <path
                    d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                  <path fill="currentColor"
                    d="M13.06 16.06a1.5 1.5 0 0 1-2.12 0l-5.658-5.656a1.5 1.5 0 1 1 2.122-2.121L12 12.879l4.596-4.596a1.5 1.5 0 0 1 2.122 2.12l-5.657 5.658Z" />
                </g>
              </svg>
            </button>
            <div v-show="nutritionOpen">
              <table class="w-full table-auto border border-collapse border-neutral-500">
                <tbody>
                  <tr v-for="(container, index) in productData.nutritionalFacts[0]
                      .servingperContainer" :key="index"
                    class="font-semibold border border-neutral-500 divide-x divide-neutral-500 text-base">
                    <td class="w-2/3 p-2 text-left">
                      {{ index == 0 ? "Serving Per Container" : "" }}
                    </td>
                    <td class="w-1/3 p-2 text-center">
                      {{ container.valueWithUnit }}
                    </td>
                  </tr>

                  <tr v-for="(size, index) in productData.nutritionalFacts[0]
                      .servingSize" :key="index"
                    class="font-semibold border border-neutral-500 divide-x divide-neutral-500 text-base">
                    <td class="w-2/3 p-2 text-left">
                      {{ index == 0 ? "Serving Size" : "" }}
                    </td>
                    <td class="w-1/3 p-2 text-center">
                      {{ size.valueWithUnit }}
                    </td>
                  </tr>

                  <tr class="font-semibold border divide-x divide-neutral-500 border-neutral-500 text-base">
                    <td class="w-2/3 p-2 text-left">Calories</td>
                    <td class="w-1/3 p-2 text-center">
                      {{ productData.nutritionalFacts[0].calories }}
                    </td>
                  </tr>

                  <template v-for="(nutrition, index) in productData.nutritionalFacts[0]
                      .item" :key="index">
                    <tr class="border divide-x divide-neutral-500 border-neutral-500">
                      <td class="w-2/3 p-2 text-left">{{ nutrition.item }}</td>
                      <td class="w-1/3 p-2 text-center">
                        {{ nutrition.valueWithUnit }}
                      </td>
                    </tr>
                    <template v-if="nutrition.subitem.length > 0">
                      <tr class="border divide-x divide-neutral-500 border-neutral-500"
                        v-for="(subNutrition, index) in nutrition.subitem" :key="index">
                        <td class="w-2/3 p-2 pl-5 text-left">
                          {{ subNutrition.name }}
                        </td>
                        <td class="w-1/3 p-2 text-center">
                          {{ subNutrition.valueWithUnit }}
                        </td>
                      </tr>
                    </template>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="flex items-center justify-center flex-col h-screen">
      <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="3rem" height="3rem" viewBox="0 0 24 24">
        <defs>
          <linearGradient id="mingcuteLoadingFill0" x1="50%" x2="50%" y1="5.271%" y2="91.793%">
            <stop offset="0%" stop-color="#FFB908" />
            <stop offset="100%" stop-color="#FFB908" stop-opacity="0.55" />
          </linearGradient>
          <linearGradient id="mingcuteLoadingFill1" x1="50%" x2="50%" y1="15.24%" y2="87.15%">
            <stop offset="0%" stop-color="#FFB908" stop-opacity="0" />
            <stop offset="100%" stop-color="#FFB908" stop-opacity="0.55" />
          </linearGradient>
        </defs>
        <g fill="none">
          <path
            d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
          <path fill="url(#mingcuteLoadingFill0)"
            d="M8.749.021a1.5 1.5 0 0 1 .497 2.958A7.502 7.502 0 0 0 3 10.375a7.5 7.5 0 0 0 7.5 7.5v3c-5.799 0-10.5-4.7-10.5-10.5C0 5.23 3.726.865 8.749.021"
            transform="translate(1.5 1.625)" />
          <path fill="url(#mingcuteLoadingFill1)"
            d="M15.392 2.673a1.5 1.5 0 0 1 2.119-.115A10.475 10.475 0 0 1 21 10.375c0 5.8-4.701 10.5-10.5 10.5v-3a7.5 7.5 0 0 0 5.007-13.084a1.5 1.5 0 0 1-.115-2.118"
            transform="translate(1.5 1.625)" />
        </g>
      </svg>
      <div class="text-Primary text-lg font-medium px-5 text-center">
        Retrieving product...
      </div>
    </div>

    <Suggested v-show="productData && suggestedLoaded" @suggestedLoaded="toggleSuggestedLoaded"
      :categoryId="route.query.categoryId" :categories="categories" :currentSelectedProduct="productId" />

    <FooterSection v-show="!loadingData && productData && suggestedLoaded" :showSubscribe="false" />
  </div>
</template>

<script setup>
import Suggested from "./Suggested.vue";
import FooterSection from "./../footer/Footer.vue";
import { computed, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { fetchData } from "@/composables/fetchData";
import { fetchFile } from "@/composables/fetchFile.js";

const route = useRoute();
const router = useRouter();
const productId = ref(route.params.id);
const productData = ref(null);
const selectedVariation = ref();

let showDesc = false;
const description = ref();
const seeMoreBtn = ref();

const multipleImg = ref(false);
const selectedVarImgs = ref([]);

const flavors = ref([]);

const nutritionOpen = ref(false);

const variationButtons = ref([]);

const suggestedLoaded = ref(false);

const toggleSuggestedLoaded = () => {
  suggestedLoaded.value = !suggestedLoaded.value;
};

const { categories, loadingData, getData, delayFinished } = fetchData(() => {
  categories.value.forEach((item) => {
    item.products.forEach((product) => {
      if (product._id == productId.value) {
        productData.value = product;

        updateSelectedVariation(productData.value.variants[0], 0);

        productData.value.specification.forEach((flavor) =>
          flavors.value.push(flavor)
        );
        loadingData.value = false;
      }
    });
  });

  if (!productData.value) {
    router.push({ name: "pagenotfound" });
  }
});

onMounted(async () => {
  await getData();
  scrollToTop();
});

const excludedFirstImage = computed(() => {
  const temp = [...selectedVarImgs.value];
  temp.shift();

  return temp.slice(0, 4);
});

function limitShow(content) {
  if (content.length > 200) return content.substring(0, 200) + "...";
  else return content;
}

function updateSelectedVariation(newVariation, index) {
  variationButtons.value.forEach((button) => {
    button.classList.remove("border-Primary");
    button.classList.add("border-neutral-300");
  });

  variationButtons.value.forEach((btn, currentIndex) => {
    if (currentIndex == index) {
      btn.classList.remove("border-neutral-300");
      btn.classList.add("border-Primary");
    }
  });

  selectedVariation.value = newVariation;

  multipleImg.value = selectedVariation.value.images.length > 1;

  selectedVarImgs.value.length = 0;

  selectedVariation.value.images.forEach((img) =>
    selectedVarImgs.value.push(img.productImgLink)
  );
  vIndex.value = index;
  vIndexImage.value = 0;
}

function toggleFullDescription() {
  if (showDesc) {
    description.value.innerText = limitShow(productData.value.description);
    showDesc = !showDesc;
    seeMoreBtn.value.innerText = "See more";
  } else {
    description.value.innerText = productData.value.description;
    showDesc = !showDesc;
    seeMoreBtn.value.innerText = "See less";
  }
}

const vIndex = ref(0);
const vIndexImage = ref(0);
const vImages = ref([]);
const imgLoading = ref(true);

watch(productData, async (product) => {
  imgLoading.value = true;

  if (Array.isArray(product?.variants)) {
    const groupedImagePromises = product.variants.map((variant) => {
      const validImageLinks = (variant.images || [])
        .filter((img) => img?.productImgLink)
        .map((img) => img.productImgLink);

      // Fetch all valid images for this variant
      return Promise.all(
        validImageLinks.map((fileUrl) =>
          fetchFile({ fileUrl, folderName: "products" })
        )
      );
    });

    vImages.value = await Promise.all(groupedImagePromises);
  } else {
    vImages.value = [];
  }

  imgLoading.value = false;
}, { immediate: true });

const selectImage = (index) => {
  vIndexImage.value = index;
}

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth", // Smooth scrolling animation
  });
};
</script>

<style></style>
